import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";

/**
 *
 *
 * 交通工具信息
 */
export class ApplyVehicleInformationApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'apply-vehicle-information'
    }




}
